const autocomplete = () => {
    const maxCachedSearches = 5;
    const inputField = document.querySelector('#autocomplete-input');
    const resultBox = document.querySelector('#autocomplete-results');
    
    if (!inputField || !resultBox) return;

    // Add click outside handler
    document.addEventListener('click', function(e) {
        // Check if click is outside both the input and results
        if (!inputField.contains(e.target) && !resultBox.contains(e.target)) {
            resultBox.classList.remove('has-results');
        }
    });

    // Click event listener
    inputField.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent document click from immediately closing
        const searchTerm = this.value.trim();

        if (!searchTerm) {
            showCachedSearches();
        }
    });

    let debounceTimer;
    let requestCounter = 0;

    // Keyup event listener
    inputField.addEventListener('keyup', function () {
        clearTimeout(debounceTimer);

        const searchTerm = this.value.trim();

        const currentRequest = ++requestCounter;

        // Set up debounce logic for input event
        debounceTimer = setTimeout(function () {
            if (searchTerm) {
                fetchSearchResults(searchTerm, currentRequest);
            } else {
                showCachedSearches();
            }
        }, 300);
    });

	// Keydown event listener for Enter key
    inputField.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            const firstResult = resultBox.querySelector('.yacht-link, .manufacturer-link');
            if (firstResult) {
                e.preventDefault(); // Prevent default form submission
                window.location.href = firstResult.href; // Redirect to the first result
            }
        }
    });

    // Retrieve cached searches from local storage
    function getCachedSearches() {
        const cached = localStorage.getItem('cachedYachtSearches');
        return cached ? JSON.parse(cached) : [];
    }

    // Save new list of cached searches to local storage
    function setCachedSearches(searches) {
        localStorage.setItem('cachedYachtSearches', JSON.stringify(searches));
    }

    // Add a new search to the cache if it's unique
    function addUniqueSearchToCache(search) {
        const cachedSearches = getCachedSearches()
            .filter(item => item.url !== search.url); // Avoid duplicates

        if (cachedSearches.length < maxCachedSearches) {
            cachedSearches.unshift(search);
        } else {
            cachedSearches.pop(); // Remove oldest if at capacity
            cachedSearches.unshift(search);
        }

        setCachedSearches(cachedSearches);
    }

	// Check if on yacht page and add to cache
    function checkAndAddCurrentYachtToCache() {
        const yachtName = document.querySelector('.article-info .h1'); // Change selector as necessary
        const yachtUrl = window.location.href;

        if (yachtName) {
            const search = {
                text: yachtName.textContent,
                url: yachtUrl
            };
            addUniqueSearchToCache(search);
        }
    }

    // Display cached searches
    function showCachedSearches() {
        const cachedSearches = getCachedSearches();
        resultBox.innerHTML = ''; // Clear results

        if (cachedSearches.length > 0) {
            const heading = document.createElement('h3');
            heading.textContent = 'Previous searches';
            resultBox.appendChild(heading);
            
            cachedSearches.forEach(search => {
                const link = document.createElement('a');
                link.href = search.url;
                link.className = 'cached-link';
                link.dataset.url = search.url;
                link.textContent = search.text;
                resultBox.appendChild(link);
            });
            
            resultBox.classList.add('has-results');
        } else {
            resultBox.classList.remove('has-results');
        }
    }

    function fetchSearchResults(searchTerm, requestId) {
        if (!searchTerm) {
            showCachedSearches();
        } 

        resultBox.innerHTML = ''; // Clear previous results
        resultBox.classList.remove('has-results');

		// AJAX request using fetch
        fetch(wpAutocomplete.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'autocomplete_search',
                term: searchTerm
            })
        })
        .then(response => response.json())
        .then(results => {
            if (requestId !== requestCounter) return;
            let hasYachts = false;
            let hasManufacturers = false;
    
            // Check and append yachts
            if (results.yachts && results.yachts.length > 0) {
                hasYachts = true;
                appendSection('Yachts', results.yachts, 'yacht-link');
            }

            // Display "No yachts found" if manufacturers exist but yachts do not
            if (!hasYachts) {
                const sectionHeader = document.createElement('h3');
                sectionHeader.textContent = 'Yachts';
                resultBox.appendChild(sectionHeader);
                const noYachtsMessage = document.createElement('a');
                noYachtsMessage.textContent = 'No yachts found.';
                resultBox.appendChild(noYachtsMessage);
            }

            // Check and append manufacturers
            if (results.manufacturers && results.manufacturers.length > 0) {
                hasManufacturers = true;
                appendSection('Builders', results.manufacturers, 'manufacturer-link');
            }

            resultBox.classList.toggle('has-results', resultBox.children.length > 0);
        })
        .catch(error => {
            console.error("Error fetching results:", error);
            resultBox.classList.remove('has-results');
        });
    }
    
    function appendSection(header, data, linkClass) {
        const sectionHeader = document.createElement('h3');
        sectionHeader.textContent = header;
        resultBox.appendChild(sectionHeader);
        appendResults(data, linkClass);
    }
    
    function appendResults(data, linkClass) {
        data.forEach(item => {
            const link = document.createElement('a');
            link.href = item.url;
            link.className = linkClass;
            link.dataset.url = item.url;
            link.textContent = item.text;
            resultBox.appendChild(link);
        });
    }

    // Delegated click event listener for dynamic content
    resultBox.addEventListener('click', function (e) {
        if (
            e.target.matches('.yacht-link') ||
            e.target.matches('.manufacturer-link') ||
            e.target.matches('.cached-link')
        ) {
            e.preventDefault();
            const linkElement = e.target;
            
            const search = {
                text: linkElement.textContent,
                url: linkElement.dataset.url
            };
            if (search.url) {
                addUniqueSearchToCache(search);
                window.location.href = search.url;
            } else {
                console.error("URL not found for the clicked link.");
            }
        }
    });

	checkAndAddCurrentYachtToCache();
};

window.addEventListener("load", (event) => {
  autocomplete();
});
function readingTimeCalculate() {
    const postContent = document.querySelector('#blog-article-content');
    if (!postContent) return;

    const textBlocks = postContent.querySelectorAll('p'); // Select all relevant text-containing elements

    let totalWords = 0;

    textBlocks.forEach(block => {
        totalWords += block.innerText.split(/\s+/).filter(word => word.length > 0).length;
    });

    const wordsPerMinute = 200; // Average reading speed
    const readingTimeMinutes = Math.ceil(totalWords / wordsPerMinute);

    const readingTimeElement = document.getElementById('estimated-reading-time');
    const categoryElement = document.querySelector('.post-category');
    const categoryName = categoryElement ? categoryElement.innerText : 'Unknown Category';

    readingTimeElement.innerHTML = `
        <p class="category-name">${categoryName}</p>
        <span class="divider">✦</span>
        <p class="reading-time">${readingTimeMinutes} Min Read</p>
        `;
}

function stickySocialLinks() {
    const blogArticleWrapper = document.querySelector(".main-content-wrapper");
    if (!blogArticleWrapper) return;

    const currentPostUrl = window.location.href; // Assume the current URL is to be used

    const socialLinks = [
        {
            socialTitle: 'Hyperlink',
            shareUrl: currentPostUrl,
        },
        {
            socialTitle: 'Instagram',
            shareUrl: 'https://www.instagram.com/create/story/?url=' + currentPostUrl,
        },
        {
            socialTitle: 'LinkedIn',
            shareUrl: 'https://www.linkedin.com/shareArticle?mini=true&url=' + currentPostUrl,
        },
        {
            socialTitle: 'Facebook',
            shareUrl: 'https://www.facebook.com/sharer/sharer.php?u=' + currentPostUrl,
        },
        {
            socialTitle: 'Twitter',
            shareUrl: 'https://twitter.com/intent/tweet?url=' + currentPostUrl,
        },
        {
            socialTitle: 'BlueSky',
            shareUrl: 'https://www.bluesky.social/share?url=' + currentPostUrl,
        }
    ];

    if (socialLinks.length > 0) {

        const socialLinksWrapperDivOuter = document.createElement('div');
        socialLinksWrapperDivOuter.className = 'container';

        const socialLinksWrapperDiv = document.createElement('div');
        socialLinksWrapperDiv.className = 'sticky-social-links-wrapper';

        const socialLinksDiv = document.createElement('div');
        socialLinksDiv.className = 'sticky-social-links';

        const footerSocialLinksWrapperDiv = document.createElement('div');
        footerSocialLinksWrapperDiv.className = 'footer-sticky-social-links-wrapper';

        const footerSocialLinksDiv = document.createElement('div');
        footerSocialLinksDiv.className = 'footer-sticky-social-links';

        socialLinks.forEach(link => {
            const socialLink = document.createElement('a');
            socialLink.href = link.shareUrl;
            socialLink.className = `social-link ${link.socialTitle.toLowerCase().replace(/\s+/g, '-')}`;
            socialLink.target = '_blank';
            socialLink.rel = 'noopener noreferrer';

            const socialLinkFooter = socialLink.cloneNode(true);

            if (link.socialTitle === 'Hyperlink') {
                const copyText = document.createTextNode('Copy link');
                socialLinkFooter.appendChild(copyText);
            }

            socialLinksDiv.appendChild(socialLink);
            footerSocialLinksDiv.appendChild(socialLinkFooter);
        });

        socialLinksWrapperDiv.appendChild(socialLinksDiv);
        socialLinksWrapperDivOuter.appendChild(socialLinksWrapperDiv);
        blogArticleWrapper.appendChild(socialLinksWrapperDivOuter);

        footerSocialLinksWrapperDiv.appendChild(footerSocialLinksDiv);

        const blogYachtswrapper = document.querySelector(".rmg-block-rmg-yachts-wrapper");

        if ( blogYachtswrapper ) {

            blogYachtswrapper.classList.add( 'container' );

            const parentDiv = blogYachtswrapper.parentNode;

            parentDiv.insertBefore(footerSocialLinksWrapperDiv, blogYachtswrapper );
        }

        //blogArticleWrapper.appendChild(footerSocialLinksWrapperDiv);
    }
}

function createTabsContent() {
    const blogArticleWrapper = document.querySelector(".main-content-wrapper");
    const introductionWrapper = document.querySelector(".rmg-block-rmg-blog-article-introduction-wrapper");

    if (!blogArticleWrapper || !introductionWrapper) return;

    const headings = blogArticleWrapper.querySelectorAll(".rmg-block-rmg-blog-article-introduction-wrapper h2, .rmg-block-rmg-blog-article-introduction-wrapper h2, .rmg-block-rmg-blog-article-image-gallery-wrapper h2, .rmg-block-rmg-blog-article-quote-wrapper h2, .rmg-block-rmg-blog-article-content-wrapper h2, .rmg-block-rmg-blog-article-content-wrapper h3, .rmg-block-rmg-blog-article-introduction-wrapper h3, .rmg-block-rmg-blog-article-introduction-wrapper h3, .rmg-block-rmg-blog-article-image-gallery-wrapper h3, .rmg-block-rmg-blog-article-quote-wrapper h3");

    // Create regular and sticky tabs containers
    const tabsContainer = document.createElement('div');
    tabsContainer.className = 'tabs-list';

    const stickyTabsContainerWrapper = document.createElement('div');
    stickyTabsContainerWrapper.className = 'sticky-tabs-list-wrapper disabled';

    const stickyTabsContainer = document.createElement('div');
    stickyTabsContainer.className = 'sticky-tabs-list container';

    headings.forEach((heading) => {
        let id = heading.textContent.trim().replace(/\s+/g, '_');

        // Create a tab link
        const tabLink = document.createElement('a');
        tabLink.href = `#${id}`;
        tabLink.className = 'tab-link';
        tabLink.textContent = heading.textContent;

        // Append the link to both containers
        tabsContainer.appendChild(tabLink.cloneNode(true));
        stickyTabsContainer.appendChild(tabLink.cloneNode(true));
    });

    const tabsContainerWrapper = document.createElement('div');
    tabsContainerWrapper.className = 'main-content';
    tabsContainerWrapper.appendChild(tabsContainer);
    stickyTabsContainerWrapper.appendChild(stickyTabsContainer);
    tabsContainerWrapper.appendChild(stickyTabsContainerWrapper);

    const parentElement = introductionWrapper.parentNode;
    if (parentElement) {
        parentElement.insertBefore(tabsContainerWrapper, introductionWrapper);
    }

    function checkVisibilityAndApplySticky() {
        const rect = tabsContainer.getBoundingClientRect();

        if (rect.bottom < 0) {
            stickyTabsContainerWrapper.classList.remove('disabled');
        } else {
            stickyTabsContainerWrapper.classList.add('disabled');
        }

        updateActiveTabStyle();

        const conclusionWrapper = document.querySelector(".rmg-block-rmg-blog-article-conclusion-wrapper");
        const stickySocialLinksWrapper = document.querySelector(".sticky-social-links-wrapper");

        if ( conclusionWrapper ) {
            if ( conclusionWrapper.getBoundingClientRect().top < 70 ) {
                stickySocialLinksWrapper.classList.add( 'd-none');
            } else {
                stickySocialLinksWrapper.classList.remove( 'd-none');
            }
        }
    }

    function updateActiveTabStyle() {
        const sections = Array.from(headings).map(heading => heading.parentElement);
        const scrollPosition = window.scrollY;

        sections.forEach(section => {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            const sectionHeight = section.offsetHeight;
            const sectionId = section.getAttribute('id');

            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                document.querySelectorAll('.sticky-tabs-list .tab-link').forEach(tab => {
                    tab.classList.remove('active');
                });
                const activeTab = document.querySelector(`.sticky-tabs-list .tab-link[href="#${sectionId}"]`);
                
                if (activeTab) {
                    activeTab.classList.add('active'); // Add active class to current tab
                }
            }
        });
    }

    checkVisibilityAndApplySticky();
    window.addEventListener('scroll', checkVisibilityAndApplySticky);
}

function scrollable() {
    const tabsList = document.querySelector('.sticky-tabs-list');
    if (!tabsList) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    // Mouse down event
    tabsList.addEventListener('mousedown', (e) => {
        isDown = true;
        tabsList.classList.add('active');
        startX = e.pageX - tabsList.offsetLeft;
        scrollLeft = tabsList.scrollLeft;
    });

    // Mouse leave event
    tabsList.addEventListener('mouseleave', () => {
        isDown = false;
        tabsList.classList.remove('active');
    });

    // Mouse up event
    tabsList.addEventListener('mouseup', () => {
        isDown = false;
        tabsList.classList.remove('active');
    });

    // Mouse move event
    tabsList.addEventListener('mousemove', (e) => {
        if (!isDown) return; // Stop if not dragging
        e.preventDefault();
        const x = e.pageX - tabsList.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed
        tabsList.scrollLeft = scrollLeft - walk;
    });

    // Optional: Enable dragging on touch devices
    tabsList.addEventListener('touchstart', (e) => {
        isDown = true;
        startX = e.touches[0].pageX - tabsList.offsetLeft;
        scrollLeft = tabsList.scrollLeft;
    });

    tabsList.addEventListener('touchend', () => {
        isDown = false;
    });

    tabsList.addEventListener('touchmove', (e) => {
        if (!isDown) return; // Stop if not dragging
        e.preventDefault();
        const x = e.touches[0].pageX - tabsList.offsetLeft;
        const walk = (x - startX) * 2; // Adjust scroll speed
        tabsList.scrollLeft = scrollLeft - walk;
    });
}

function loadMore() {
    const loadMoreButton = document.getElementById('load-more');
    
    if (!loadMoreButton) return;

    loadMoreButton.addEventListener('click', function() {
        
        const authorId = loadMoreButton.dataset.author;
        const page = parseInt(loadMoreButton.dataset.page, 10);

        loadMoreButton.disabled = true;
        loadMoreButton.textContent = 'Loading...';

        fetch(wpAutocomplete.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_more_articles',
                author: authorId,
                page: page
            })
        })
        .then(response => response.text())
        .then(data => {
            if (data.trim()) {
                const articlesList = document.querySelector('.articles-list');
                if (articlesList) {
                    articlesList.insertAdjacentHTML('beforeend', data);
                }
                loadMoreButton.dataset.page = page + 1; // Increment page number

                // Hide button if no more articles
                if (data.trim() === '') {
                    loadMoreButton.style.display = 'none';
                }
            } else {
                loadMoreButton.style.display = 'none';
            }
        })
        .catch(() => {
            console.error('Error loading articles.');
        })
        .finally(() => {
            // Re-enable the button after the fetch completes
            loadMoreButton.disabled = false;
            loadMoreButton.textContent = 'Load more articles';
        });
    });
}

if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', readingTimeCalculate );
    document.addEventListener("DOMContentLoaded", stickySocialLinks);
    document.addEventListener("DOMContentLoaded", createTabsContent);
    document.addEventListener("DOMContentLoaded", scrollable);
    document.addEventListener("DOMContentLoaded", loadMore);
} else {
	readingTimeCalculate();
    stickySocialLinks();
    createTabsContent();
    scrollable();
    loadMore();
}
// Currency conversion logic
async function handleCurrencyConversion() {
    const currencyMap = {
        'US': 'USD', 'CA': 'CAD', 'GB': 'GBP', 'AT': 'EUR', 'BE': 'EUR',
        'HR': 'EUR', 'CY': 'EUR', 'EE': 'EUR', 'FI': 'EUR', 'FR': 'EUR',
        'DE': 'EUR', 'GR': 'EUR', 'IE': 'EUR', 'IT': 'EUR', 'LV': 'EUR',
        'LT': 'EUR', 'LU': 'EUR', 'MT': 'EUR', 'NL': 'EUR', 'PT': 'EUR',
        'SK': 'EUR', 'SI': 'EUR', 'ES': 'EUR', 'CH': 'CHF', 'AU': 'AUD',
        'BR': 'BRL', 'CN': 'CNY', 'HK': 'HKD', 'JP': 'JPY', 'NZ': 'NZD'
    };

    let selectedCurrency;

    // Clear the selectedCurrency every hour
    setInterval(() => {
        localStorage.removeItem('selectedCurrency');
        fetchAndUpdateCurrency();  // Refresh currency based on updated logic
    }, 3600000);

    async function fetchAndUpdateCurrency() {
        const storedCurrency = localStorage.getItem('selectedCurrency');
        if (!storedCurrency) {
            try {
                const userCountry = userData.country;  // Fetch current country
                selectedCurrency = currencyMap[userCountry] || 'USD';
            } catch (error) {
                selectedCurrency = 'USD'; // Default to USD on error
            }
        } else {
            selectedCurrency = storedCurrency;
        }

        displayCurrency(selectedCurrency);
    }

    function toggleDropdown() {
        const dropdownContent = document.getElementById("currencyDropdownContent");
        dropdownContent.classList.toggle("show");

        const chevron = document.querySelector('.chevron');
        if (chevron) {
            chevron.classList.toggle('rotate');
        }
    }

    function selectCurrency(currency) {
        // Save selected currency to localStorage only on explicit user selection
        localStorage.setItem('selectedCurrency', currency);

        const dropdownContent = document.getElementById("currencyDropdownContent");
        dropdownContent.classList.remove("show");

        const chevron = document.querySelector('.chevron');
        if (chevron) {
            chevron.classList.remove('rotate');
        }

        // Trigger event for other parts of the app to listen to
        window.dispatchEvent(new CustomEvent('currencyChanged', { detail: currency }));
        
        displayCurrency(currency);
    }

    function displayCurrency(currency) {
        document.getElementById("selectedCurrency").textContent = currency || "Currency not available";

        const options = document.querySelectorAll('.currency-option');
        options.forEach(option => {
            option.classList.toggle('selected', option.getAttribute('data-value') === currency);
        });
    }

    document.getElementById('currencyDropdown').addEventListener('click', toggleDropdown);

    const currencyOptions = document.querySelectorAll('.currency-option');
    currencyOptions.forEach(option => {
        option.addEventListener('click', function() {
            selectCurrency(this.getAttribute('data-value'));
        });
    });

    window.onclick = function(event) {
        if (!event.target.matches('.currency-selector') && 
            !event.target.matches('.currency-selector *')) {
            const dropdownContent = document.getElementById("currencyDropdownContent");
            dropdownContent.classList.remove("show");

            const chevron = document.querySelector('.chevron');
            if (chevron) {
                chevron.classList.remove('rotate');
            }
        }
    }

    await fetchAndUpdateCurrency();  // Initial invocation to set things up
}

window.addEventListener("load", (event) => {
  handleCurrencyConversion();
});
const subscriptionForm = () => {

    const formEl = document.getElementById('footer-subscription');

    if ( !formEl ) return;

    formEl.addEventListener('submit', event => {
		
		event.preventDefault()
		event.stopPropagation()

		formEl.classList.add( 'was-validated' );

		if ( formEl.checkValidity() ) {
			handleFormSubmit();
		}

	}, false );

}

const handleFormSubmit = async () => {

    const userEmail = document.getElementById('footerSubscriptionEmail');

    if ( ! userEmail ) return;

	const successMsgEl = document.getElementById('subscription-success');
	const errorMsgEl = document.getElementById('subscription-error');
	const formEl = document.getElementById('footer-subscription');
	const submitBtn = document.getElementById('subscription-submit-btn');

	const fetchUrl = `${window.location.origin}/wp-json/yachtcom/v1/addusertoonesignal/?user_email=${userEmail.value}`;

	submitBtn.setAttribute( 'disabled', true );

	try{

		const response = await fetch( fetchUrl );
		
		const responseJson = await response.json();

		if ( responseJson ) {

			if ( responseJson.success === true ) {
				formEl.classList.add( 'd-none' );
				successMsgEl.classList.remove( 'd-none' );
				successMsgEl.classList.add('d-inline-block');
				formEl.classList.remove( 'was-validated' );
			} else {
				if ( responseJson.error_msg.length > 1 ) {
					errorMsgEl.innerHTML = responseJson.error_msg;
				}

				userEmail.setAttribute( 'invalid', true );
				
			}

			formEl.reset();

		}

	} catch( error ) {
		console.log( error );
		return error;
	}

	submitBtn.setAttribute( 'disabled', false );
}

window.addEventListener("load", (event) => {
  subscriptionForm();
});
function gtag() {
	if (window.dataLayer) {
		window.dataLayer.push(arguments);
	} else {
		console.warn('dataLayer not available');
	}
}

function isDescendant( parent, child ) {
	let node = child.parentNode;
	while ( node != null ) {
		if ( node === parent ) {
			return true;
		}
		node = node.parentNode;
	}
	return false;
}

function findAncestorByTagName(element, tagName) {
	tagName = tagName.toUpperCase();
	while (element) {
		if (element.tagName === tagName) {
			return element;
		}
		element = element.parentElement;
	}
	return null;
}

function handleExternalLinks() {
	const currentHost = window.location.host;
	document.querySelectorAll( `a:not([href*="${currentHost}"]):not([href^="tel:"]):not([href^="mailto:"]):not([href^="#"]):not([href^="/"])` ).forEach( ( a ) => {
		a.setAttribute( 'target', '_blank' );
		a.setAttribute( 'rel', 'noopener noreferrer' );
	} );
}

function handleAmenitiesNav() {
	document.querySelectorAll( '#amenities-nav a' ).forEach( ( link ) => {
		link.addEventListener( 'click', ( event ) => {
			event.preventDefault();
			document.querySelectorAll( '#amenities-nav a.active' ).forEach( ( activeLink ) => {
				activeLink.classList.remove( 'active' );
				activeLink.setAttribute( 'aria-selected', 'false' );
			} );
			link.classList.add( 'active' );
			link.setAttribute( 'aria-selected', 'true' );
			const target = document.querySelector( link.getAttribute( 'href' ) );
			if ( target ) {
				if ( isDescendant( document.querySelector( '#nav-all' ), link ) ) {
					document.querySelectorAll( '.amenities-group' ).forEach( ( group ) => {
						group.classList.remove( 'hidden' );
					} );
				} else {
					document.querySelectorAll( '.amenities-group' ).forEach( ( group ) => {
						group.classList.add( 'hidden' );
					} );
					target.classList.remove( 'hidden' );
				}
			}
		} );
	} );
}

function imperialMetricToggle() {
	document.querySelectorAll( '.unit-switcher button' ).forEach( ( switcher ) => {
		switcher.addEventListener( 'click', ( event ) => {
			document.querySelectorAll( '.unit-switcher button' ).forEach( ( button ) => {
				button.classList.toggle( 'active' );
			} );
			document.querySelectorAll( 'dd .imperial, dd .metric' ).forEach( ( output ) => {
				output.classList.toggle( 'hidden' );
			} );
		} );
	} );
}

function remotelyCollapseDetails() {
	document.querySelectorAll( '.collapse' ).forEach( ( button ) => {
		button.addEventListener( 'click', ( event ) => {
			const detailsElement = findAncestorByTagName( button, 'details' );
			if (detailsElement) {
				detailsElement.open = false;
				const summaryElement = detailsElement.querySelector('summary');
				if (summaryElement) {
					summaryElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}
		} );
	} );
}

function truncateHTML(html, maxWords) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html; // Set HTML content in a temporary div
    const words = tempDiv.innerText.split(' '); // Extract plain text to count words

    if (words.length <= maxWords) {
        return html; // Return original HTML if it's already within the word limit
    }

    let truncated = '';
    let wordCount = 0;

    function traverseNodes(node) {
        if (wordCount >= maxWords) return; // Stop if maxWords is reached

        if (node.nodeType === Node.TEXT_NODE) {
            // Split the text node into words
            const textWords = node.nodeValue.split(' ');

            for (const word of textWords) {
                if (wordCount < maxWords) {
                    truncated += word + ' ';
                    wordCount++;
                } else {
                    truncated = truncated.trim() + '...';
                    break;
                }
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Add the opening tag for the element
            truncated += `<${node.tagName.toLowerCase()}`;
            
            // Add attributes (if any)
            for (let attr of node.attributes) {
                truncated += ` ${attr.name}="${attr.value}"`;
            }
            truncated += '>'; // Close opening tag

            // Recursively process child nodes
            for (let childNode of node.childNodes) {
                traverseNodes(childNode);
                if (wordCount >= maxWords) break;
            }

            // Add the closing tag
            truncated += `</${node.tagName.toLowerCase()}>`;
        }
    }

    // Traverse the nodes in the temporary div
    for (const childNode of tempDiv.childNodes) {
        traverseNodes(childNode);
        if (wordCount >= maxWords) break;
    }

    return truncated.trim();
}

function handleMoreLinksOnTax() {
	const contentElement = document.querySelector('.about-details .content');

    if(!contentElement) return;
	const toggleLink = document.querySelector('.more-less');
	
	const originalHTML = contentElement.innerHTML; // Get original HTML
	const maxWords = 60; // Maximum number of words to show initially
	const truncatedHTML = truncateHTML(originalHTML, maxWords);

	if (truncatedHTML !== originalHTML) {
		contentElement.innerHTML = truncatedHTML; // Set truncated HTML
	} else {
		toggleLink.style.display = 'none'; // Hide toggle link if text is already short
	}

	contentElement.style.display = 'block';

	toggleLink.addEventListener('click', function (e) {
		e.preventDefault(); // Prevent the default link behavior

		if (contentElement.classList.contains('expanded')) {
			// Collapse the text
			contentElement.innerHTML = truncateHTML(originalHTML, maxWords);

		} else {
			// Expand the text
			contentElement.innerHTML  = originalHTML;
		}

		contentElement.classList.toggle('expanded'); // Toggle the 'expanded' class on the content
		toggleLink.classList.toggle('expanded'); // Toggle the 'expanded' class on the link
	});	  
}

function getElementWidth(className) {
    let width = 0;
    const element = document.querySelector('.' + className);
    if (element) {
        width = Math.round(element.clientWidth); // Use clientWidth for a more accurate width
    }
    return width;
}

function generateCloudinaryImgUrl() {
	const className = 'secondary-image';
    const width = getElementWidth(className);
    updateImageSources('.dynamic-image', width);
    updateImageSources('.primary-image img', getElementWidth('primary-image'));
}

function updateImageSources(selector, newWidth) {
    const images = document.querySelectorAll(selector);
    images.forEach(function(image) {
        const imageSrc = image.getAttribute('src');
        const newSrc = replaceImageWidth(imageSrc, newWidth);
        image.setAttribute('src', newSrc);
    });
}

function replaceImageWidth(src, width) {
    return src.replace(/w_\d+/, 'w_' + width);
}

function handleExpandableContent() {
    const container = document.querySelector('.expandable-content-container');
	if (!container) return;
    const showButton = container.querySelector('.show-button');
	const hideButton = container.querySelector('.hide-button');

    showButton.addEventListener('click', () => {
        container.classList.add('expanded');
    });

	hideButton.addEventListener('click', () => {
        container.classList.remove('expanded');
    });
}

function handleGalleryModal() {
    var body = document.querySelector('body');
    var modal = document.getElementById("gallery-modal");
    if (!modal) {
        return;
    }
    const content = modal.querySelector('.modal-content');
    var btns = document.getElementsByClassName("gallery-modal-toggle");
    var closeBtns = document.getElementsByClassName('modal-close-btn');

    function openModal(index) {
        modal.style.display = "block";
        body.classList.add('gallery-modal-open');
        
        const container = modal.querySelector('.gallery-container');
        const item = container.children[index];
        if (item) {
            content.scrollTo({
                top: index > 0 ? item.offsetTop - 100 : 0,
                behavior: 'instant'
            });
        }

        // Push state with modal open
        history.pushState({ modalOpen: true, galleryIndex: index }, '', '?modal=open&galleryIndex=' + index);
    }

    function closeModal() {
        modal.style.display = "none";
        body.classList.remove('gallery-modal-open');

        // Replace state to reflect modal is closed
        history.replaceState({}, '', window.location.pathname);
    }

    // Attach onclick handlers for opening the modal
    for (var i = 0; i < btns.length; i++) {
        btns[i].onclick = function() {
            const index = this.getAttribute('data-gallery-index') || 0;
            openModal(index);
        };
    }

    // Attach onclick handlers for closing the modal
    for (var i = 0; i < closeBtns.length; i++) {
        closeBtns[i].onclick = closeModal;
    }

    // Listening to popstate events
    window.addEventListener('popstate', function(event) {
        if (event.state && event.state.modalOpen) {
            openModal(event.state.galleryIndex || 0);
        } else {
            closeModal();
        }
    });

    // Initial load: open modal if URL indicates it's open
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('modal') === 'open' && urlParams.has('galleryIndex')) {
        const index = parseInt(urlParams.get('galleryIndex'), 10) || 0;
        openModal(index);
        history.replaceState({ modalOpen: true, galleryIndex: index }, '', window.location.href);
    }
}

function createGalleryToggle() {
	const state = {
		isFullView: true,
		instances: new Map()
	};
 
	function initToggle(containerSelector, gallerySelector) {
		const container = document.querySelector(containerSelector);
		if (!container) return;
		const slider = container.querySelector('.gallery-toggle__slider');
		const fullButton = container.querySelector('.gallery-toggle__button--full');
		const listButton = container.querySelector('.gallery-toggle__button--list');
		const galleryContainer = document.querySelector(gallerySelector);
 
		state.instances.set(containerSelector, {
			container, slider, fullButton, listButton, galleryContainer
		});
 
		fullButton.addEventListener('click', () => updateAllToggles(true));
		listButton.addEventListener('click', () => updateAllToggles(false));
 
		updateToggle(containerSelector, true);
	}
 
	function updateToggle(containerSelector, isFullView) {
		const { container, slider, fullButton, listButton, galleryContainer } = state.instances.get(containerSelector);
		const containerWidth = container.offsetWidth;
		const newPosition = isFullView ? 0 : containerWidth / 2 - 8;
 
		slider.style.transform = `translateX(${newPosition}px)`;
		isFullView ? galleryContainer.classList.remove('grid-view') : galleryContainer.classList.add('grid-view');
		
		fullButton.setAttribute('aria-pressed', isFullView);
		listButton.setAttribute('aria-pressed', !isFullView);
	}
 
	function updateAllToggles(isFullView) {
		state.isFullView = isFullView;
		state.instances.forEach((_, selector) => updateToggle(selector, isFullView));
	}
 
	return {
		init: initToggle
	};
 }

function handleGalleryToggle() {
    const galleryComponents = createGalleryToggle();
    galleryComponents.init('#sticky-toggle-container', '.gallery-container');
    galleryComponents.init('#toggle-container', '.gallery-container');
}


function scrollToTop() {
	const galleryContainer = document.getElementById('gallery-modal').querySelector('.modal-content');
	galleryContainer.scrollTo({ top: 0, behavior: 'smooth' });
}

function handleModalScroll() {
	const modal = document.getElementById('gallery-modal');
	if (!modal) return;
	const modalContent = modal.querySelector('.modal-content');
	const scrollToTopBtn = document.querySelector('.scroll-to-top');
	const stickyHeader = modal.querySelector('#sticky-header');
	let lastScrollTop = 0;
 
	modalContent.addEventListener('scroll', () => {
		const scrollTop = modalContent.scrollTop;
		

		if (scrollTop > 300) {
			stickyHeader.classList.add('show');
		} else {
			stickyHeader.classList.remove('show');
		}

		if (scrollTop > lastScrollTop) {
			if (scrollTop > 300) {
				scrollToTopBtn.classList.remove('show');
			}
		} else {
			if (scrollTop > 300) {
				scrollToTopBtn.classList.add('show');
			} else {
				scrollToTopBtn.classList.remove('show');
			}
		}
 
		lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
	}, false);
 
	scrollToTopBtn.addEventListener('click', scrollToTop);
 }

async function initGallery() {
	const galleryContainer = document.getElementById('yacht-gallery');
	if (galleryContainer) {
		const isMobile = window.innerWidth <= 768;
		
		lightGallery(galleryContainer, {
			plugins: [lgZoom, lgThumbnail],
			licenseKey: '169B92A4-B2CB-4329-836E-3526ABC43306',
			speed: 500,
			download: false,
            thumbnail: !isMobile, // Hide thumbnails on mobile devices
            exThumbImage: 'data-thumbnail',
            toggleThumb: true, // Hide thumbnail toggle on mobile devices
            allowMediaOverlap: true,
		});
	}
}

function handleExpandableYachtDetails() {
	const container = document.querySelector('.lmg-yacht-details-wrapper');
	if (!container) return;
    const content = container.querySelector('.yacht-details');
    const toggleButton = container.querySelector('button.btn-link');

	toggleButton.addEventListener('click', () => {
        container.classList.toggle('expanded');
    });
}

function handleExpandableBuilders() {
    const buttons = document.querySelectorAll('.view-more-btn');

    buttons.forEach(button => {
        button.addEventListener('click', function () {
            const parent = button.closest('.tab-pane');
            const hiddenItems = parent.querySelectorAll('.manufacturer-list-item.hidden');
            const builders = Array.from(parent.querySelectorAll('.manufacturer-list-item'));

            // Toggle "View More" / "View Less"
            if (button.textContent === 'View More') {
                // Show all hidden items
                hiddenItems.forEach(item => item.classList.remove('hidden'));
                button.textContent = 'View Less';
				button.classList.remove('view-more-btn');
                button.classList.add('view-less-btn');
            } else {
                // Hide items with less than 10 yachts, except for the builder with the most yachts
                builders.forEach(builder => {
                    const yachtsCount = parseInt(builder.getAttribute('data-yachts-count') || 0, 10);
					const maxYachtsCount = builder.getAttribute('data-max-yachts');
                    if (yachtsCount < 3 && maxYachtsCount !== 'true') {
                        builder.classList.add('hidden');
                    } else {
                        builder.classList.remove('hidden'); // Ensure visible items remain visible
                    }
                });
                button.textContent = 'View More';
				button.classList.remove('view-less-btn');
                button.classList.add('view-more-btn');
            }

            // Ensure the builder with the most yachts is always visible
            if (maxYachtsBuilder) {
                maxYachtsBuilder.classList.remove('hidden');
            }
        });
	});
}

function handleContactForm() {
    const form = document.getElementById('contact-form');
    if (!form) return;

	const urlParams = new URLSearchParams(window.location.search);
	const actionFor = urlParams.get('for');

    const responseEl = document.getElementById('form-response');
	const submitButton = form.querySelector('button[type=submit]');
	const topicSelect = form.querySelector('[name="topic"]');
	const formSections = {
		'Claim a yacht': '.yacht-charter-form',
		'Charter a yacht': '.yacht-charter-form', 
		'Get featured': '.get-featured-form'
	};
	
	topicSelect.addEventListener('change', () => {
		const selectedValue = topicSelect.value;
		form.classList.remove('was-validated');
	
		Object.values(formSections).forEach(selector => {
			const section = form.querySelector(selector);
			const isSelected = Object.entries(formSections)
				.filter(([, value]) => value === selector)
				.some(([key]) => key === selectedValue);
	
			section.style.display = isSelected ? 'flex' : 'none';
			section.querySelectorAll('[required]').forEach(field => {
				field.disabled = !isSelected;
			});
		});
	});
	

	if (actionFor) {
		topicSelect.value = actionFor;
		topicSelect.dispatchEvent(new Event('change'));
	}

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

		submitButton.classList.add('sending');

        if (!form.checkValidity()) {
            form.classList.add('was-validated');
			submitButton.classList.remove('sending');
            return;
        }
    
        const formData = new FormData(form);
        formData.append('action', 'submit_contact_form');
    
        try {
            const response = await fetch(contactConfig.ajaxurl, {
                method: 'POST',
                body: formData
            });
            const data = await response.json();
            
            responseEl.textContent = data.message;
            responseEl.className = data.success ? 'alert alert-success' : 'alert alert-danger';
            
            if (data.success) {
                form.reset();
                form.classList.remove('was-validated');
            }
        } catch (error) {
            responseEl.textContent = 'An error occurred';
            responseEl.className = 'alert alert-danger';
        }
		submitButton.classList.remove('sending');
    });
}


function verifyRecaptchaCallback(response) {
    const recaptchaInput = document.querySelector('input[data-recaptcha]');
    if (recaptchaInput) {
        recaptchaInput.value = response;
    }
};

function expiredRecaptchaCallback() {
    const recaptchaInput = document.querySelector('input[data-recaptcha]');
    if (recaptchaInput) {
        recaptchaInput.value = "";
    }
};

function autocomplete2() {
    const maxCachedSearches = 5;
    const inputField = document.querySelector('#autocomplete-input-2');
    const resultBox = document.querySelector('#autocomplete-results-2');
    
    if (!inputField || !resultBox) return;

    // Add click outside handler
    document.addEventListener('click', function(e) {
        // Check if click is outside both the input and results
        if (!inputField.contains(e.target) && !resultBox.contains(e.target)) {
            resultBox.classList.remove('has-results');
        }
    });

    // Click event listener
    inputField.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent document click from immediately closing
        const searchTerm = this.value.trim();

        if (!searchTerm) {
            showCachedSearches();
        }
    });

    let debounceTimer;
    let requestCounter = 0;

    // Keyup event listener
    inputField.addEventListener('keyup', function () {
        clearTimeout(debounceTimer);

        const searchTerm = this.value.trim();

        const currentRequest = ++requestCounter;

        // Set up debounce logic for input event
        debounceTimer = setTimeout(function () {
            if (searchTerm) {
                fetchSearchResults(searchTerm, currentRequest);
            } else {
                showCachedSearches();
            }
        }, 300);
    });

	// Keydown event listener for Enter key
    inputField.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            const firstResult = resultBox.querySelector('.yacht-link, .manufacturer-link');
            if (firstResult) {
                e.preventDefault(); // Prevent default form submission
                window.location.href = firstResult.href; // Redirect to the first result
            }
        }
    });

    // Retrieve cached searches from local storage
    function getCachedSearches() {
        const cached = localStorage.getItem('cachedYachtSearches');
        return cached ? JSON.parse(cached) : [];
    }

    // Save new list of cached searches to local storage
    function setCachedSearches(searches) {
        localStorage.setItem('cachedYachtSearches', JSON.stringify(searches));
    }

    // Add a new search to the cache if it's unique
    function addUniqueSearchToCache(search) {
        const cachedSearches = getCachedSearches()
            .filter(item => item.url !== search.url); // Avoid duplicates

        if (cachedSearches.length < maxCachedSearches) {
            cachedSearches.unshift(search);
        } else {
            cachedSearches.pop(); // Remove oldest if at capacity
            cachedSearches.unshift(search);
        }

        setCachedSearches(cachedSearches);
    }

	// Check if on yacht page and add to cache
    function checkAndAddCurrentYachtToCache() {
        const yachtName = document.querySelector('.article-info .h1'); // Change selector as necessary
        const yachtUrl = window.location.href;

        if (yachtName) {
            const search = {
                text: yachtName.textContent,
                url: yachtUrl
            };
            addUniqueSearchToCache(search);
        }
    }

    // Display cached searches
    function showCachedSearches() {
        const cachedSearches = getCachedSearches();
        resultBox.innerHTML = ''; // Clear results

        if (cachedSearches.length > 0) {
            const heading = document.createElement('h3');
            heading.textContent = 'Previous searches';
            heading.classList.add(...['fs-mono-sm', 'text-metal-600']);
            resultBox.appendChild(heading);
            
            cachedSearches.forEach(search => {
                const link = document.createElement('a');
                link.href = search.url;
                link.className = 'cached-link';
                link.textContent = search.text;
                resultBox.appendChild(link);
            });
            
            resultBox.classList.add('has-results');
        } else {
            resultBox.classList.remove('has-results');
        }
    }

    function fetchSearchResults(searchTerm, requestId) {
        if (!searchTerm) {
            showCachedSearches();
        } 

        resultBox.innerHTML = ''; // Clear previous results
        resultBox.classList.remove('has-results');

		// AJAX request using fetch
        fetch(wpAutocomplete.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'autocomplete_search',
                term: searchTerm
            })
        })
        .then(response => response.json())
        .then(results => {
            if (requestId !== requestCounter) return;
            let hasYachts = false;
            let hasManufacturers = false;
    
            // Check and append yachts
            if (results.yachts && results.yachts.length > 0) {
                hasYachts = true;
                appendSection('Yachts', results.yachts, 'yacht-link');
            }

            // Display "No yachts found" if manufacturers exist but yachts do not
            if (!hasYachts) {
                const sectionHeader = document.createElement('h3');
                sectionHeader.textContent = 'Yachts';
                sectionHeader.classList.add(...['fs-mono-sm', 'text-metal-600']);
                resultBox.appendChild(sectionHeader);
                const noYachtsMessage = document.createElement('a');
                noYachtsMessage.textContent = 'No yachts found.';
                noYachtsMessage.classList.add(...['fs-mono-sm', 'text-metal-600']);
                resultBox.appendChild(noYachtsMessage);
            }

            // Check and append manufacturers
            if (results.manufacturers && results.manufacturers.length > 0) {
                hasManufacturers = true;
                appendSection('Builders', results.manufacturers, 'manufacturer-link');
            }

            resultBox.classList.toggle('has-results', resultBox.children.length > 0);
        })
        .catch(error => {
            console.error("Error fetching results:", error);
            resultBox.classList.remove('has-results');
        });
    }
    
    function appendSection(header, data, linkClass) {
        const sectionHeader = document.createElement('h3');
        sectionHeader.textContent = header;
        sectionHeader.classList.add(...['fs-mono-sm', 'text-metal-600']);
        resultBox.appendChild(sectionHeader);
        appendResults(data, linkClass);
    }
    
    function appendResults(data, linkClass) {
        data.forEach(item => {
            const link = document.createElement('a');
            link.href = item.url;
            link.className = linkClass;
            link.dataset.url = item.url;
            link.textContent = item.text;
            resultBox.appendChild(link);
        });
    }

    // Delegated click event listener for dynamic content
    resultBox.addEventListener('click', function (e) {
        if (
            e.target.matches('.yacht-link') ||
            e.target.matches('.manufacturer-link') ||
            e.target.matches('.cached-link')
        ) {
            e.preventDefault();
            const linkElement = e.target;
            
            const search = {
                text: linkElement.textContent,
                url: linkElement.dataset.url
            };
            if (search.url) {
                addUniqueSearchToCache(search);
                window.location.href = search.url;
            } else {
                console.error("URL not found for the clicked link.");
            }
        }
    });

	checkAndAddCurrentYachtToCache();
};

function handleBookingYacht() {
    const requestButtonElements = document.getElementsByClassName('request-charter');
    Array.from(requestButtonElements).forEach(function(requestButtonElement) {
        requestButtonElement.addEventListener('click', function() {
            const triggerButtonElement = document.getElementById('book-yacht-charter');
            if (triggerButtonElement) { // Ensure the element exists before clicking it
                triggerButtonElement.click();
            }
        });
    });
}

function initYachtHeaderSwiper() {
    if (typeof Swiper === 'undefined' || window.innerWidth >= 768) return;
    
    const swiperElement = document.querySelector('.yacht-header-swiper');
    if (!swiperElement) return;

    const yachtHeaderSwiper = new Swiper('.yacht-header-swiper', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        preloadImages: false,
        lazyPreloadPrevNext: 3,
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction'
        },
        navigation: false
    });

    // Store swiper instance on the element
    swiperElement.swiperInstance = yachtHeaderSwiper;
}


function destinationAutocomplete() {
    const inputField = document.querySelector('#autocomplete-destination-input');
    const resultBox = document.querySelector('#autocomplete-destination-results');
    
    if (!inputField || !resultBox) return;

    let recommendedDestinations = [];
    let debounceTimer;
    let requestCounter = 0; // Track current requests

    document.addEventListener('click', function(e) {
        if (!inputField.contains(e.target) && !resultBox.contains(e.target)) {
            resultBox.classList.remove('has-results');
        }
    });

    inputField.addEventListener('click', function (e) {
        e.stopPropagation();
        showSuggestionDestinations();
    });

    inputField.addEventListener('keyup', function () {
        clearTimeout(debounceTimer);

        const searchTerm = this.value.trim();
        const currentRequest = ++requestCounter;

        if (!searchTerm) {
            removeFetchedResults();
            displayRecommendedDestinations();
            return;
        }

        debounceTimer = setTimeout(function () {
            fetchDestinationResults(searchTerm, currentRequest);
        }, 300);
    });

    inputField.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            const firstResult = resultBox.querySelector('.destination-link');
            if (firstResult) {
                e.preventDefault();
                window.location.href = firstResult.href;
            }
        }
    });

    function getSuggestionDestinations() {
        return new Promise((resolve, reject) => {
            fetch(wpAutocomplete.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: new URLSearchParams({
                    action: 'get_suggestion_destinations'
                })
            })
            .then(response => response.json())
            .then(data => {
                recommendedDestinations = data;
                resolve(data);
            })
            .catch(error => {
                console.error('Error fetching suggestion destinations:', error);
                reject(error);
            });
        });
    }

    function showSuggestionDestinations() {
        if (recommendedDestinations.length > 0) {
            displayRecommendedDestinations();
        } else {
            getSuggestionDestinations().then(displayRecommendedDestinations);
        }
    }

    function displayRecommendedDestinations() {
        const recommendedContainer = document.createElement('div');
        recommendedContainer.className = 'recommended-section';

        if (recommendedDestinations.length > 0) {
            const heading = document.createElement('h3');
            heading.textContent = 'RECOMMENDED';
            heading.classList.add(...['fs-mono-sm', 'text-metal-600']);
            recommendedContainer.appendChild(heading);

            recommendedDestinations.forEach(search => {
                const container = createSuggestionContainer(search);
                recommendedContainer.appendChild(container);
            });

            const existingSection = resultBox.querySelector('.recommended-section');
            if (existingSection) {
                existingSection.replaceWith(recommendedContainer);
            } else {
                resultBox.appendChild(recommendedContainer);
            }

            resultBox.classList.add('has-results');
        }
    }

    function createSuggestionContainer(destination) {
        const container = document.createElement('a');
        container.className = 'suggestion-container';
        container.href = destination.link;
        container.dataset.url = destination.link;

        const image = document.createElement('img');
        // Process Cloudinary URL to ensure correct dimensions
        let imageUrl = destination.cover_image;
        if (imageUrl && imageUrl.includes('cloudinary.com')) {
            imageUrl = imageUrl.replace(/\/w_\d+,h_\d+/, '/w_48,h_48');
        }
        image.src = imageUrl;
        image.alt = `${destination.name} cover image`;
        image.className = 'suggestion-image';
        
        const link = document.createElement('a');
        link.href = destination.link;
        link.dataset.url = destination.link;
        link.className = 'destination-link';
        link.textContent = destination.name;

        const parentName = document.createElement('p');
        parentName.className = 'parent-name';
        parentName.textContent = destination.parent_name;

        const name = document.createElement('div');
        name.className = 'suggestion-name';

        container.appendChild(image);
        name.appendChild(link);
        name.appendChild(parentName);
        container.appendChild(name);

        return container;
    }

    function fetchDestinationResults(searchTerm, requestId) {
        // Clear only the dynamic search results before fetching new ones
        removeFetchedResults();

        fetch(wpAutocomplete.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                action: 'destinations_autocomplete_search',
                term: searchTerm
            })
        })
        .then(response => response.json())
        .then(results => {
            if (requestId !== requestCounter) return; // Process only the latest request

            let hasDestinations = results && results.length > 0;
            const dynamicResultsContainer = document.createElement('div');
            dynamicResultsContainer.className = 'dynamic-results';

            if (hasDestinations) {
                appendResults(results, dynamicResultsContainer);
            }

            // Show dynamic results above recommendations
            resultBox.insertBefore(dynamicResultsContainer, resultBox.firstChild);

            resultBox.classList.toggle('has-results', resultBox.children.length > 1);
        })
        .catch(error => {
            console.error("Error fetching results:", error);
            resultBox.classList.remove('has-results');
        });
    }

    function removeFetchedResults() {
        const dynamicResultsSection = resultBox.querySelector('.dynamic-results');
        if (dynamicResultsSection) {
            dynamicResultsSection.remove();
        }
    }

    function appendResults(data, container) {
        data.forEach(item => {
            const link = createSuggestionContainer(item);
            container.appendChild(link);
        });

        const sectionHeader = document.createElement('h3');
        sectionHeader.textContent = 'DESTINATIONS';
        sectionHeader.classList.add(...['fs-mono-sm', 'text-metal-600']);
        container.insertBefore(sectionHeader, container.firstChild);
    }

    resultBox.addEventListener('click', function (e) {
        if (e.target.matches('.destination-link') || e.target.matches('.cached-link')) {
            e.preventDefault();
            const linkElement = e.target;
            
            const search = {
                text: linkElement.textContent,
                url: linkElement.dataset.url
            };
            if (search.url) {
                window.location.href = search.url;
            } else {
                console.error("URL not found for the clicked link.");
            }
        }
    });

    getSuggestionDestinations();
}

// Modified resize listener with better error handling
window.addEventListener('resize', () => {
    const swiperElement = document.querySelector('.yacht-header-swiper');
    if (!swiperElement || !swiperElement.swiperInstance) return;
    
    if (window.innerWidth >= 768) {
        try {
            swiperElement.swiperInstance.destroy(true, true);
            swiperElement.swiperInstance = null;
        } catch (error) {
            console.warn('Error destroying Swiper instance:', error);
        }
    }
});

function handleYachtFAQ() {
    const faqItems = document.querySelectorAll('.yacht-faq-section .faq-item');
    if (!faqItems.length) return;
    
    faqItems.forEach(item => {
        const wrapper = item.querySelector('.faq-item-wrapper');
        const header = wrapper.querySelector('.faq-header');
        const question = wrapper.querySelector('.faq-question');
        const answer = wrapper.querySelector('.faq-answer');
        
        if (!question || !answer || !header) return;
        
        // Create text span
        const textSpan = document.createElement('span');
        textSpan.className = 'question-text';
        textSpan.textContent = question.textContent.trim();
        
        // Clear and rebuild question
        question.innerHTML = '';
        question.appendChild(textSpan);
        
        // Set initial state
        if (!item.classList.contains('active')) {
            answer.setAttribute('aria-hidden', 'true');
        }
        
        // Add click event listener to the entire header
        header.addEventListener('click', function() {
            toggleFAQ(item, answer);
        });
    });
}

function toggleFAQ(item, answer) {
    const isActive = item.classList.contains('active');
    
    if (isActive) {
        item.classList.remove('active');
        answer.setAttribute('aria-hidden', 'true');
    } else {
        item.classList.add('active');
        answer.setAttribute('aria-hidden', 'false');
    }
}

function initYachtLocationMap() {
    const mapElement = document.getElementById('yacht-location-map');
    if (!mapElement || typeof mapboxgl === 'undefined') return;
    
    const mapboxToken = mapElement.getAttribute('data-mapbox-api-key') || '';
    const mapStyle = 'mapbox://styles/mapbox/satellite-streets-v12';
    
    const lat = parseFloat(mapElement.getAttribute('data-lat') || '43.7102');
    const lon = parseFloat(mapElement.getAttribute('data-lon') || '5.9333');
    
    const destinationIsSame = mapElement.getAttribute('data-destination-same') === 'true';
    const destinationName = mapElement.getAttribute('data-destination') || '';
    const lastPortName = mapElement.getAttribute('data-last-port') || '';
    const currentLocationName = mapElement.getAttribute('data-current-location') || '';
    
    const currentCoords = [lon, lat]; 
    
    const fullscreenIconSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2188 7.71875C10.925 8.0125 10.925 8.4875 11.2188 8.77812C11.5125 9.06875 11.9875 9.07187 12.2781 8.77812L16.4969 4.55938V7.25C16.4969 7.66563 16.8313 8 17.2469 8C17.6625 8 17.9969 7.66563 17.9969 7.25V2.75C17.9969 2.33437 17.6625 2 17.2469 2H12.75C12.3344 2 12 2.33437 12 2.75C12 3.16562 12.3344 3.5 12.75 3.5H15.4406L11.2188 7.71875ZM8.78125 12.2812C9.075 11.9875 9.075 11.5125 8.78125 11.2219C8.4875 10.9313 8.0125 10.9281 7.72188 11.2219L3.5 15.4406V12.75C3.5 12.3344 3.16562 12 2.75 12C2.33437 12 2 12.3344 2 12.75V17.25C2 17.6656 2.33437 18 2.75 18H7.25C7.66563 18 8 17.6656 8 17.25C8 16.8344 7.66563 16.5 7.25 16.5H4.55938L8.78125 12.2812Z" fill="#03045E"/>
    </svg>`;
    
    const closeIconSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.28086 3.2187C3.98711 2.92808 3.51211 2.92808 3.21836 3.2187C2.92461 3.50933 2.92773 3.98745 3.21836 4.2812L8.93711 9.99995L3.21836 15.7187C2.92461 16.0125 2.92461 16.4875 3.21836 16.7781C3.51211 17.0687 3.98711 17.0718 4.27773 16.7781L9.99648 11.0593L15.7184 16.7812C16.0121 17.075 16.4871 17.075 16.7777 16.7812C17.0684 16.4875 17.0715 16.0125 16.7777 15.7218L11.059 10.0031L16.7809 4.2812C17.0746 3.98745 17.0746 3.51245 16.7809 3.22183C16.4871 2.9312 16.0121 2.92808 15.7215 3.22183L10.0027 8.94058L4.28086 3.2187Z" fill="#03045E"/>
    </svg>`;
    
    if (!mapboxToken) {
        console.error('Mapbox token is missing');
        return;
    }
    
    mapboxgl.accessToken = mapboxToken;
    
    const map = new mapboxgl.Map({
        container: 'yacht-location-map',
        style: mapStyle,
        projection: 'globe',
        center: currentCoords,
        zoom: 11,
        dragPan: true,
        dragRotate: true,
        scrollZoom: true,
        touchZoomRotate: true,
        touchPitch: true
    });
    
    function updateFullscreenButton(fullscreenBtn) {
        fullscreenBtn.innerHTML = document.fullscreenElement ? closeIconSvg : fullscreenIconSvg;
    }
    
    function toggleFullscreen(element, fullscreenBtn) {
        if (!document.fullscreenElement) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }
    
    function createCurvedLine(startPoint, endPoint, curveIntensity = 0.2, pointCount = 20) {
        const points = [startPoint];
        
        const dx = endPoint[0] - startPoint[0];
        const dy = endPoint[1] - startPoint[1];
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance < 0.05) {
            return [startPoint, endPoint];
        }
        
        let adjustedIntensity = curveIntensity;
        if (distance < 0.5) {
            adjustedIntensity = curveIntensity * (distance * 2);
        } else if (distance > 2) {
            adjustedIntensity = Math.min(curveIntensity * 1.5, 0.3);
        }
        
        const perpLength = Math.sqrt(dx * dx + dy * dy);
        const offsetX = (-dy / perpLength) * adjustedIntensity;
        const offsetY = (dx / perpLength) * adjustedIntensity;
        
        for (let i = 1; i < pointCount + 1; i++) {
            const t = i / (pointCount + 1);
            
            let px = startPoint[0] * (1 - t) + endPoint[0] * t;
            let py = startPoint[1] * (1 - t) + endPoint[1] * t;
            
            const offset = 4 * t * (1 - t);
            px += offsetX * offset;
            py += offsetY * offset;
            
            points.push([px, py]);
        }
        
        points.push(endPoint);
        return points;
    }
    
    async function geocodeLocation(location) {
        if (!location || !mapboxToken || location === 'At sea') return null;
        
        try {
            // Get the corresponding country code based on location type
            let countryCode = '';
            const mapElement = document.getElementById('yacht-location-map');
            
            if (location === mapElement.getAttribute('data-current-location')) {
                countryCode = mapElement.getAttribute('data-current-port-country');
            } else if (location === mapElement.getAttribute('data-last-port')) {
                countryCode = mapElement.getAttribute('data-last-port-country');
            } else if (location === mapElement.getAttribute('data-destination')) {
                countryCode = mapElement.getAttribute('data-destination-country');
            }
            
            // Add country code to the geocoding request if available
            let geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(location)}.json?access_token=${mapboxToken}&limit=1`;
            
            if (countryCode) {
                geocodingUrl += `&country=${countryCode}`;
            }
            
            const response = await fetch(geocodingUrl);
            
            if (!response.ok) {
                throw new Error('Geocoding request failed');
            }
            
            const data = await response.json();
            
            if (data.features && data.features.length > 0) {
                const feature = data.features[0];
                return feature.center;
            }
            
            return null;
        } catch (error) {
            console.error('Error geocoding location:', error);
            return null;
        }
    }
    
    const controlsContainer = document.createElement('div');
    controlsContainer.className = 'map-controls-container';
    mapElement.appendChild(controlsContainer);
    
    const fullscreenControl = document.createElement('button');
    fullscreenControl.className = 'map-control-fullscreen';
    fullscreenControl.innerHTML = fullscreenIconSvg;
    controlsContainer.appendChild(fullscreenControl);
    
    map.addControl(new mapboxgl.NavigationControl(), 'top-right');
    
    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'].forEach(eventType => {
        document.addEventListener(eventType, () => updateFullscreenButton(fullscreenControl));
    });
    
    fullscreenControl.addEventListener('click', () => toggleFullscreen(mapElement, fullscreenControl));
    
    map.on('load', async function() {
        const createMarkerElement = (className, imgSrc) => {
            const element = document.createElement('div');
            element.className = className;
            
            if (imgSrc) {
                const img = document.createElement('img');
                img.src = imgSrc;
                element.appendChild(img);
            }
            
            return element;
        };
        
        const bounds = new mapboxgl.LngLatBounds().extend(currentCoords);
        
        const currentLocationEl = createMarkerElement('current-location-marker', '/wp-content/themes/yacht.com/assets/img/current-location.png');
        new mapboxgl.Marker(currentLocationEl).setLngLat(currentCoords).addTo(map);

        if (lastPortName && lastPortName !== currentLocationName) {
            const lastPortCoords = await geocodeLocation(lastPortName);
            
            if (lastPortCoords) {
                const lastPortEl = createMarkerElement('last-port-marker', '/wp-content/themes/yacht.com/assets/img/starting-pin.png');
                new mapboxgl.Marker(lastPortEl).setLngLat(lastPortCoords).addTo(map);
                bounds.extend(lastPortCoords);
                
                map.addSource('yacht-route', {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: createCurvedLine(lastPortCoords, currentCoords, 0.03, 20)
                        }
                    }
                });
                
                map.addLayer({
                    id: 'yacht-route',
                    type: 'line',
                    source: 'yacht-route',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': 'rgba(225, 176, 54, 1)',
                        'line-width': 3
                    }
                });
            }
        }
        
        if (!destinationIsSame && destinationName) {
            const destinationCoords = await geocodeLocation(destinationName);
            
            if (destinationCoords) {
                const destinationEl = createMarkerElement('destination-marker');
                new mapboxgl.Marker(destinationEl).setLngLat(destinationCoords).addTo(map);
                bounds.extend(destinationCoords);
                
                map.addSource('destination-route', {
                    type: 'geojson',
                    data: {
                        type: 'Feature',
                        properties: {},
                        geometry: {
                            type: 'LineString',
                            coordinates: createCurvedLine(currentCoords, destinationCoords, 0.02, 20)
                        }
                    }
                });
                
                map.addLayer({
                    id: 'destination-route',
                    type: 'line',
                    source: 'destination-route',
                    layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    paint: {
                        'line-color': 'rgba(225, 176, 54, 0.6)',
                        'line-width': 2,
                        'line-opacity': 0.8,
                        'line-dasharray': [2, 2]
                    }
                });
            }
        }
   
        
        map.fitBounds(bounds, {
            padding: 80,
            maxZoom: 11
        });
    });
}

function copyClipboard() {
    const copyLinks = document.querySelectorAll('.hyperlink');

    copyLinks.forEach(copyLink => {
        copyLink.addEventListener('click', function(event) {
            event.preventDefault(); 

            navigator.clipboard.writeText(window.location.href)
                .then(() => {
                    showTooltip(copyLink, 'Copied!');
                })
                .catch(err => {
                });
        });
    });
}

function showTooltip(element, message) {
    if (!(element instanceof HTMLElement)) {
        return;
    }
    
    // Create a tooltip element
    const tooltip = document.createElement('span');
    tooltip.textContent = message;
    tooltip.style.position = 'absolute';
    tooltip.style.backgroundColor = '#333';
    tooltip.style.color = '#fff';
    tooltip.style.padding = '5px 10px';
    tooltip.style.borderRadius = '4px';
    tooltip.style.fontSize = '12px';
    tooltip.style.zIndex = '1000';

    // Position the tooltip
    const rect = element.getBoundingClientRect();
    tooltip.style.top = rect.top + window.scrollY - 30 + 'px'; // Adjust as needed
    tooltip.style.left = rect.left + window.scrollX + 'px';

    document.body.appendChild(tooltip);

    // Remove the tooltip after 2 seconds
    setTimeout(() => {
        tooltip.remove();
    }, 2000);
}

// Destinations and rates seasonal price updater.
const seasonCurrencyMap = {
    'USD': '$',
    'CAD': '$',
    'EUR': '€',
    'GBP': '£',
    'CHF': 'CHF',
    'AUD': '$',
    'BRL': 'R$',
    'CNY': '￥',
    'HKD': '$',
    'JPY': '¥'
};

const seasonPriceUpdate = ( currentCurrency ) => {
    
    const seasonPriceElements = document.getElementsByClassName( "season-price-wrap" );

    if ( seasonPriceElements && seasonPriceElements.length > 0 ) {
        
        Array.from(seasonPriceElements).forEach( async (element) => {

            const priceNumberEl = element.querySelector( '.season-price-number' );

            if ( priceNumberEl && priceNumberEl.dataset.seasonPrice ) {
                
                const priceNumber = parseInt( priceNumberEl.dataset.seasonPrice, 10 );

                await updateSeasonPriceOnEvent( currentCurrency, priceNumber, element );

            }

        });

    }
}

const updateSeasonPriceOnEvent = async ( selectedCurrency, price, element ) => {

    const rate = await fetchExchangeRateFromStorage(selectedCurrency);
    const convertedPrice = roundDownAmount(Math.round(price * rate));
    const symbol = seasonCurrencyMap[selectedCurrency] || '';
    const formatted = new Intl.NumberFormat('en-US').format(convertedPrice);

    const priceNumberEl = element.querySelector( '.season-price-number' );
    const currencySymbolEl = element.querySelector( '.season-price-currency-sign' );
    const currencyEl = element.querySelector( '.season-price-currency' );

    priceNumberEl.innerHTML = formatted;
    currencySymbolEl.innerHTML = symbol;
    currencyEl.innerHTML = selectedCurrency;

};

const roundDownAmount = (amount) => {
    const numDigits = Math.floor(Math.log10(amount)) + 1; // Get number of digits
    const roundingFactor = Math.pow(10, Math.max(numDigits - 3, 3)); // Determine rounding factor

    return Math.floor(amount / roundingFactor) * roundingFactor;
}

const fetchExchangeRateFromStorage = (selectedCurrency) => {
    const rates = yachtBookingData.exchangeRates;
    return rates && rates[yachtBookingData.currency] ? rates[yachtBookingData.currency][selectedCurrency] : 1;
};

const initialSeasonPriceUpdate = () => {
    let currentCurrency = localStorage.getItem('selectedCurrency') || 'USD';
        
    seasonPriceUpdate( currentCurrency );
}

// Trigger seasonal price updater on currency change.
window.addEventListener('currencyChanged', ( event ) => {
    
    const selectedCurrency = event.detail;

    if (seasonCurrencyMap[selectedCurrency]) {
        seasonPriceUpdate( selectedCurrency );
    }

});

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet, set an event listener
	document.addEventListener( 'DOMContentLoaded', handleExternalLinks );
	document.addEventListener( 'DOMContentLoaded', handleAmenitiesNav );
	document.addEventListener( 'DOMContentLoaded', imperialMetricToggle );
	document.addEventListener( 'DOMContentLoaded', remotelyCollapseDetails );
	document.addEventListener( 'DOMContentLoaded', handleMoreLinksOnTax );
	document.addEventListener( 'DOMContentLoaded', handleExpandableContent );
	document.addEventListener( 'DOMContentLoaded', generateCloudinaryImgUrl );
	document.addEventListener( 'DOMContentLoaded', handleGalleryModal );
	document.addEventListener( 'DOMContentLoaded', handleGalleryToggle );
	document.addEventListener( 'DOMContentLoaded', handleModalScroll );
	document.addEventListener( 'DOMContentLoaded', initGallery );
	document.addEventListener( 'DOMContentLoaded', handleExpandableYachtDetails );
	document.addEventListener( 'DOMContentLoaded', handleExpandableBuilders );
	document.addEventListener( 'DOMContentLoaded', handleContactForm );
	document.addEventListener( 'DOMContentLoaded', verifyRecaptchaCallback );
	document.addEventListener( 'DOMContentLoaded', expiredRecaptchaCallback );
    document.addEventListener( 'DOMContentLoaded', autocomplete2 );
    document.addEventListener( 'DOMContentLoaded', handleBookingYacht );
    document.addEventListener( 'DOMContentLoaded', initYachtHeaderSwiper );
    document.addEventListener( 'DOMContentLoaded', destinationAutocomplete );
    document.addEventListener( 'DOMContentLoaded', handleYachtFAQ );
    document.addEventListener( 'DOMContentLoaded', initYachtLocationMap );
    document.addEventListener( 'DOMContentLoaded', copyClipboard );
    document.addEventListener( 'DOMContentLoaded', showTooltip );
    document.addEventListener( 'DOMContentLoaded', initialSeasonPriceUpdate );
} else {
	// `DOMContentLoaded` has already fired, run the func directly
	handleExternalLinks();
	handleAmenitiesNav();
	imperialMetricToggle();
	remotelyCollapseDetails();
	handleMoreLinksOnTax();
	handleExpandableContent();
	generateCloudinaryImgUrl();
	handleGalleryModal();
	handleGalleryToggle();
	handleModalScroll();
	initGallery();
	handleExpandableYachtDetails();
	handleExpandableBuilders();
	handleContactForm();
	verifyRecaptchaCallback();
	expiredRecaptchaCallback();
    autocomplete2();
    handleBookingYacht();
    initYachtHeaderSwiper();
    destinationAutocomplete();
    handleYachtFAQ();
    initYachtLocationMap();
    copyClipboard();
    initialSeasonPriceUpdate();
    showTooltip();
}

document.addEventListener('DOMContentLoaded', function() {
    // Initialize general toggles
    handleToggle('.mobile-nav-toggle', 'nav-open');
    handleToggle('.mobile-autocomplete-toggle', 'autocomplete-open');

    // Setup mobile-specific toggles initially
    setupMobileToggles();

    // Handle window resize events
    window.addEventListener('resize', resizeHandler);
});

let mobileSpecificToggles = [];

function setupMobileToggles() {
    const isMobile = window.innerWidth < 768;
    
    // Remove previous listeners if any exist
    mobileSpecificToggles.forEach(({ element, handler }) => {
        element.removeEventListener('click', handler);
    });
    mobileSpecificToggles = [];

    if (isMobile) {
        const autocompleteInputHandler = () => openAutocompleteDestination();
        const autocompleteButtonHandler = () => toggleBodyClass('autocomplete-destination-open');
        const autocompleteButtonHandler1 = () => toggleBodyClass('autocomplete-open');

        attachMobileListener('#autocomplete-destination-input', autocompleteInputHandler);
        attachMobileListener('#btn-destination-autocomplete-toggle', autocompleteButtonHandler);
        attachMobileListener('.mobile-directory-autocomplete-toggle', autocompleteButtonHandler1);
    }
}

function attachMobileListener(selector, handler) {
    const element = document.querySelector(selector);
    if (element) {
        element.addEventListener('click', handler);
        mobileSpecificToggles.push({ element, handler });
    }
}

function resizeHandler() {
    closeClassOnResize(['nav-open', 'autocomplete-open', 'autocomplete-destination-open']);
    setupMobileToggles(); // Re-establishing mobile-specific toggles

    if (window.innerWidth < 768) {
        // Handle removal of 'has-results' class during resize
        const resultsElement = document.querySelector('#autocomplete-destination-results');
        if (resultsElement && resultsElement.classList.contains('has-results')) {
            resultsElement.classList.remove('has-results');
        }
    }
}

function handleToggle(selector, toggleClass) {
    const toggleElement = document.querySelector(selector);
    if (toggleElement) {
        toggleElement.addEventListener('click', function() {
            toggleBodyClass(toggleClass);
        });
    }
}

function toggleBodyClass(className) {
    document.body.classList.toggle(className);
}

function closeClassOnResize(classesToClose) {
    if (window.innerWidth >= 768) {
        classesToClose.forEach(cls => document.body.classList.remove(cls));
    }
}

function openAutocompleteDestination() {
    // Check if 'autocomplete-destination-open' class is already present
    if (!document.body.classList.contains('autocomplete-destination-open')) {
        document.body.classList.add('autocomplete-destination-open');
    }
}

const rmgOverflowXScroll = ( withinElementId = null ) => {
	let scrollable;

	if ( typeof (withinElementId) == 'undefined' ) {
		scrollable = document.querySelectorAll( '.overflow-x-container' );
	} else {
		try {
			const obj = document.getElementById( withinElementId );
			if ( obj !== null ) {
				scrollable = obj.querySelectorAll( '.overflow-x-container' );
			} else {
				scrollable = document.querySelectorAll( '.overflow-x-container' );
			}
		} catch ( error ) {
			scrollable = document.querySelectorAll( '.overflow-x-container' );
		}
	}

	if ( scrollable.length > 0 ) {
		scrollable.forEach( ( el ) => {
			const content = el.querySelector( '.overflow-x-content' );
			if ( ! content ) return;

			const backButton = el.querySelector( '.overflow-x-backward' );
			const forwardButton = el.querySelector( '.overflow-x-forward' );

			const farEdge = content.scrollWidth;

			// debugging: if farEdge and clientWidth are the same value, overflowXScroll is being called before the overflow-x-content box is populated and needs to be called afterwards so it can get the correct width
			// console.log( content.scrollLeft, farEdge, content.clientWidth );

			// scroll to the left each time called
			content.scrollLeft = 0;

			// assuming we have set things up so there is no overlap of a single card on the edge
			// (that is, the cards fill up 100% of the available space)
			// if there is a column gap applied, add that value to the scroll amount
			// this ensures that each click moves the cards so they are aligned full left afterward and the complete card is visible
			let columnGap = 0;
			let columnGapStyle = window.getComputedStyle( content ).getPropertyValue( 'column-gap' );

			// levels of care cards which are unique to this site use the RMG Cards as a block and the overflow-x-content class gets applied to the wrapper rather than the ul containing the cards so we have to drill down one more
			if ( content.classList.contains( 'levels-of-care-cards' ) ) {
				columnGapStyle = window.getComputedStyle( content.querySelector( '.rmg-cards-wrapper' ) ).getPropertyValue( 'column-gap' );
			}

			if ( columnGapStyle ) {
				const columnGapNumber = Number( columnGapStyle.slice( 0, -2 ) );
				if ( ! isNaN( columnGapNumber ) ) {
					columnGap = columnGapNumber;
				}
			}


			if ( el.scrollLeft > 0 && backButton ) {
				backButton.disabled = false;
			} else if ( backButton ) {
				backButton.setAttribute( 'disabled', 'true' );
			}

			// if the container is already scrolled right, or
			// if the content is less than the client width, disable the forward button
			if ( forwardButton && (el.scrollLeft >= farEdge || content.scrollWidth <= el.clientWidth) ) {
				forwardButton.setAttribute( 'disabled', 'true' );
			} else if ( forwardButton ) {
				forwardButton.disabled = false;
			}

			content.addEventListener( 'scroll', () => {
				if ( content.scrollLeft > 0 && backButton ) {
					backButton.disabled = false;
				} else if ( backButton ) {
					backButton.setAttribute( 'disabled', 'true' );
				}

				if ( content.scrollLeft < farEdge - content.clientWidth && forwardButton ) {
					forwardButton.disabled = false;
				} else if ( forwardButton ) {
					forwardButton.setAttribute( 'disabled', 'true' );
				}
			} );

			if ( backButton ) {
				backButton.addEventListener( 'click', function () {
					if ( content.scrollLeft > content.clientWidth ) {
						content.scroll( { left: content.scrollLeft -= (content.clientWidth + columnGap) } );
					} else {
						content.scroll( { left: content.scrollLeft = 0 } );
						backButton.setAttribute( 'disabled', 'true' );
					}
					this.blur();
				} );
			}

			if ( forwardButton ) {
				forwardButton.addEventListener( 'click', function () {
					if ( Math.ceil(content.scrollLeft) < farEdge - content.clientWidth ) {
						content.scroll( { left: content.scrollLeft += (content.clientWidth + columnGap) } );
					} else {
						forwardButton.setAttribute( 'disabled', 'true' );
						content.scroll( { left: content.scrollLeft = farEdge } );
					}
					this.blur();
				} );
			}
		} );
	}
}

window.addEventListener( 'resize', rmgOverflowXScroll );

if ( document.readyState === 'loading' ) {
	// Loading hasn't finished yet
	document.addEventListener( 'DOMContentLoaded', rmgOverflowXScroll );
} else {
	// `DOMContentLoaded` has already fired
	rmgOverflowXScroll();
}
